<ngx-spinner
      bdColor="rgba(75, 55, 100, 0.5)"
      size="large"
      color="#fff"
      type="line-scale-pulse-out">
          <span class="chevron left"></span>
          <span class="chevron right"></span>
    </ngx-spinner>

<div class="generic-modal-root">  
    <div class="row-padding">
      <div class="row" style="margin-top: 0;">
        <form
          *ngIf="form"
          [formGroup]="form"
          class="m-form m-form--fit m-form--label-align-right"
        >
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Name </label>
            <div class="col-lg-8">
              <input
                formControlName="name"
                type="text"
                class="form-control m-input"
              />
              <app-validation-display
              [control]="form.controls.name"
              errorMessage="Please enter a valid name for this game."
            ></app-validation-display>
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Campaign </label>
            <div class="col-lg-8" style="align-self: center;">
              <select
                  formControlName="pledgePerWinId"
                  class="col-lg-12 col-m-4 form-control m-input"
                  id="pledgePerWinId"
                  (change)="onChangeCampaign($event)"
                  >
                  <option selected value="0">-- Select a Campaign --</option>
                  <option
                  *ngFor="let ppw of ppws"
                  [selected]="ppw.pledgePerWinId === form.controls.pledgePerWinId.value"
                  [value]="ppw.pledgePerWinId"    
                  >
                  {{ ppw.event.name }}
                  </option>
								</select>
              <app-validation-display
                [control]="form.controls.pledgePerWinId"
                errorMessage="Please select a valid Campaign."
              ></app-validation-display>
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Date Completed </label>
            <div class="col-lg-8" style="align-self: center;">
              <input type="datetime-local" formControlName="dateCompleted"/>
              <app-validation-display
                [control]="form.controls.dateCompleted"
                errorMessage="Date completed is required."
							></app-validation-display>
            </div>
          </div>
          <div class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label"> Custom Email/Text Message: </label>
            <div class="col-lg-8">
              <textarea
                formControlName="message"
                type="text"
                class="form-control m-input"
              ></textarea>
              <app-validation-display
                [control]="form.controls.message"
                errorMessage="Please enter a valid message."
              ></app-validation-display>
            </div>
          </div>
          <div *ngIf="statistic" class="form-group m-form__group row remove-margin">
            <label class="col-lg-4 col-form-label">Number of {{statistic}}(s) </label>
            <div class="col-lg-8">
              <input
                formControlName="chargeCount"
                type="number"
                class="form-control m-input"
              />
              <app-validation-display
              [control]="form.controls.chargeCount"
              errorMessage="Please enter a valid number of {{statistic}}(s)."
            ></app-validation-display>
            </div>
          </div>
  
          <div style="display: flex; justify-content: space-between;">
            <button
              [disabled]="gameId > 0"
              (click)="openConfirmDialog()"
              class="btn btn-success"
              style="margin:10px; float:right"
            >
              Confirm
            </button>
            <button
              (click)="close()"
              class="btn btn-success"
              style="margin:10px; float:right"
            >
              Close
            </button>
          </div>
          <div *ngIf="hasValidationErrors">
            <span style="color:red">Please complete the required fields</span>
          </div>
        </form>
      </div>
    </div>
  </div>